module.exports = {
	config: {
		lastMileSelector: 	'section.elements',
		open:               false,
		registerType:       'elementContainer',
		registerSecret:     '',
		static: {
			title: 	'TITLE NOT DEFINED',
			icon: 	''
		}
	},

	model: {
		headOptions: {}
	},

	methods: {
		activate: function(){
			var hadClass = this.$.hasClass('active');
			if(!hadClass) this.triggerFind('preElementFocus');
			const classes = ['active']
			if(this.config.bootstrapVersion){
				this.$.find('.head > button')
					.removeClass('collapsed')
				this.$.find('.contentContainer')
					.addClass('accordion-collapse show')
					.removeClass('collapsed')
			}
			this.$.addClass(classes.join(' '));
			this.config.open = true;
			if(!hadClass) this.triggerFind('postElementFocus');
		},

		deactivate: function(){
			var hadClass = this.$.hasClass('active');
			if(hadClass) this.triggerFind('preElementBlur');
			const classes = ['active']
			if(this.config.bootstrapVersion){
				this.$.find('.head > button')
					.addClass('collapsed')
				this.$.find('.contentContainer')
					.removeClass('accordion-collapse show')
					.addClass('collapsed')
			}
			this.$.removeClass(classes.join(' '));
			this.config.open = false;
			if(hadClass) this.triggerFind('postElementBlur');
		},

		toggle: function(){
			if(this.$.hasClass('active')){
				this.deactivate();
			} else {
				this.activate();
			}
		},

		mark: function(type, addType){
			const $target = this.$.find('> .head > button')
			if($target.length > 0 && type){
				if(addType){
					this.$.addClass(type)
				}
				else {
					this.$.removeClass(type)
				}
			} else {
				console.error('mark() not possible: missing target or type:', $target, type)
			}
		},

		close: function(restoreActiveElement){
			var self = this;
			if(self.config.registerSecret){
				self.closest('base_accordion_accordion', accordion => {
					accordion.removeElement(self.config.registerSecret, restoreActiveElement);
				});
			}
		},

		remove: function(){
			this.destroy();
		}
	},

	hooks: {
		attach: function($element){
			if(this.config.open){
				$element.addClass('active');
			}
		},
	}
};
